import { ReactNode } from "react";
import { Draggable, Droppable } from "react-beautiful-dnd";

export const MyDroppable = (props: { id: string; type: string; children: ReactNode }) => {
  const grid = 8;

  const getListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? "lightgrey" : "",
    padding: grid,
    // width: 250
  });

  return (
    <Droppable key={props.id} droppableId={props.id} type={props.type}>
      {(provider, snapshot) => (
        <div ref={provider.innerRef} {...provider.droppableProps} style={getListStyle(snapshot.isDraggingOver)}>
          {props.children}
          {provider.placeholder}
        </div>
      )}
    </Droppable>
  );
};
